import { render, staticRenderFns } from "./CoinHistory.vue?vue&type=template&id=0937f05f&scoped=true&"
import script from "./CoinHistory.vue?vue&type=script&lang=js&"
export * from "./CoinHistory.vue?vue&type=script&lang=js&"
import style0 from "./CoinHistory.vue?vue&type=style&index=0&id=0937f05f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937f05f",
  null
  
)

export default component.exports